import emailjs from "@emailjs/browser";

export class Mail {
  id: string;
  formHtml: HTMLFormElement | undefined;
  btnHtml: HTMLElement | undefined;

  constructor(mailFormId: string, btn: string) {
    this.id = mailFormId;
    const formHtml: HTMLFormElement = <HTMLFormElement>(
      document.getElementById(mailFormId)
    );
    const btnHtml = document.getElementById(btn);
    emailjs.init("XU8SkiSsQpMLCUr5-");
    if (formHtml && btnHtml) {
      this.formHtml = formHtml;
      this.btnHtml = btnHtml;
      this.formHtml.addEventListener("submit", (e: Event) => {
        e.preventDefault();
        if (this.isValid()) {
          if (this.btnHtml)
          this.btnHtml.innerText = "Envoie...";

          const serviceID = "default_service";
          const templateID = "template_82jd5rb";

          if (this.formHtml)
          emailjs.sendForm(serviceID, templateID, this.formHtml).then(
            () => {
              if (this.btnHtml)
              this.btnHtml.innerText = "Message envoyé!";
              this.cleanForm();
            },
            (err) => {
              if (this.btnHtml)
              this.btnHtml.innerText = "Erreur d'envoi!";
              console.error(JSON.stringify(err));
            }
          );
        }
      });
    }
  }

  private isHere(): boolean {
    if (this.formHtml) {
      return true;
    }
    return false;
  }

  private isValid(): boolean {
    let out = true;
    if (this.isHere()) {
      const form = Array.prototype.slice
        .call(document.forms)
        .filter((form) => form.id === this.id);
      if (form[0]) {
        const form_data = new FormData(form[0]);
        for (const item of form[0].elements) {
          const elem = item as HTMLElement;
          const attributes = elem.getAttributeNames();
          if (attributes.includes("required")) {
            const name = elem.getAttribute("name");
            if (name && !form_data.get(name)) {
              out = false;
            }
          }
        };
      } else {
        out = false;
      }
    } else {
      out = false;
    }
    return out;
  }

  private cleanForm() {
    if (this.formHtml) {
      this.formHtml.reset();
    }
  }
}
